<template>
  <div class="mywxdetail">
    <h3>{{form.projectName}}：{{form.projectCode}}
    </h3>
    <el-row class="idata">
      <el-col :span="8"><span class="color_red">{{form.amount}}<sub>元</sub></span>出借金额</el-col>
      <el-col :span="8"><span>{{form.yieldRate}}<sub>%</sub></span>期望收益率</el-col>
      <el-col :span="8"><span>{{form.deadline}}<sub>天</sub></span>出借期限</el-col>
    </el-row>
    <el-row class="desc">
      <el-col :span="24">
        出借方：{{form.lenders}}<br />
        发布日期：{{form.publishTime}}<br />
        要求保证方式：{{form.guaranteeMethod}}<br />
      </el-col>
    </el-row>
    <div class="db_desc_more">
      <template>
        <el-tabs type="border-card" value="first" stretch>
          <el-tab-pane label="项目简介" name="first">
            <div v-html="form.projectDescription" class="tab_con"></div>
          </el-tab-pane>
          <el-tab-pane label="项目资料" name="second">
            <div class="tab_con">
              <el-row id="projectImg" :gutter="5">
                <el-col v-for="img in files" :span="12" :key="img.id">
                  <el-card shadow="hover">
                    <img :id="img.id" :src="downloadFileURL+img.url+'/'" @click="showImg()">
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="借入记录" name="third">
            <div class="tab_con">
              <el-table :data="intentions" highlight-current-row style="width: 100%;" border>
                <el-table-column prop="username" label="借入人" align="center"></el-table-column>
                <el-table-column prop="phoneNumber" label="联系方式" align="center"></el-table-column>
                <el-table-column prop="contractAmount" label="借入金额(元)" align="center"></el-table-column>
                <el-table-column prop="transDate" label="借入日期" align="center" :formatter="formatDate"></el-table-column>
              </el-table>
              <!--<el-pagination-->
                <!--background-->
                <!--@current-change="handleCurrentChange"-->
                <!--:page-size="pageSize"-->
                <!--layout="prev, pager, next"-->
                <!--:total="total">-->
              <!--</el-pagination>-->
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>
    </div>

    <div class="btns_bottom">
      <a class="btn_b"  href="javascript:void(0);" v-if="form.realTimeStatus === 1" v-bind:class="{btn_d:form.realTimeStatus === 1}">已完成</a>
      <a class="btn_b"  href="javascript:void(0);" v-else-if="form.realTimeStatus === 2" v-bind:class="{btn_d:form.realTimeStatus === 2}">已过期</a>
      <a class="btn_b" v-else @click="checkUnprocessedIntention">项目详情</a>
      <router-link class="btn_c" :to="{path:'wxProjectList'}">返回项目列表</router-link>
    </div>

    <!-- 弹出层 -->
    <el-dialog width="90%" title="提示消息" :visible.sync="tipsVisible" top="36vh" center>
      <el-row>
        <el-col id="tmessage">
          温馨提示：确认了解该项目详细信息？
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tipsVisible=false">取 消</el-button>
        <el-button type="primary" @click="sendIntention">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="90%" title="提示消息" :visible.sync="dialogMsgVisible" top="36vh" center>
      <el-row>
        <el-col>
          温馨提示：您的信息已成功发送。平台将会在24小时内与您联系，或者您还可以拨打客服热线 <a href="tel:4000297800">400-029-7800</a> 直接了解项目信息。
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogMsgVisible=false">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="90%" title="提示消息" :visible.sync="popupMsgVisible" top="36vh" center>
      <el-row>
        <el-col>
          温馨提示：您的项目意向尚未处理完成，请勿重复操作。
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="popupMsgVisible = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import util from '../../common/util'
  import {reqGetOneLoanProject} from '../../api/weixin-api';
  import {reqGetDictionaryByIdList,reqGetAttachmentsByProjId,downloadFileURL,} from '../../api/weixin-api';
  import {reqGetBorrowIntentionByProjIdPage,reqBorrowIntentionAdd,reqQueryUnprocessedIntention} from '../../api/weixin-api';
  import '../../common/viewer.min.css';
  import Viewer from '../../common/viewer.min';

  export default {
    data(){
      return{
        total:0,
        pageNum:1,
        pageSize:5,
        projectStatusArray:[],
        projectDetailBannerImage:{},
        form: {
          id:'',
          projectName:'',
          projectCode:'',
          lenders:'',
          amount:'',
          deadline:'',
          yieldRate:'',
          firstAmount:'',
          repaymentMethod:'',
          guaranteeMethod:'',
          projectDescription:'',
          attachmentIds:'',
          projectStatus:'',
          realTimeStatus:'',
          projectStatusCode:'',
          publishTime:'',
          quickMark:''
        },
        files:[],
        intentions:[],
        downloadFileURL: downloadFileURL,
        tipsVisible:false,
        dialogMsgVisible:false,
        popupMsgVisible:false,
      }
    },
    methods:{
      showImg(){
        $('#projectImg').viewer({
          movable:false
        });
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.currentPage = val;
        this.getIntentions(this.form.id);
      },
      checkUnprocessedIntention:function(){
        this.dialogMsgVisible = false;
        this.popupMsgVisible = false;
        this.tipsVisible = false;
        reqQueryUnprocessedIntention({projectId:this.form.id,authorization: window.localStorage.getItem('Authorization')}).then((res) => {
          if(res.data.code != 1){
            this.tipsVisible = true;

          }else {
            this.popupMsgVisible = true;
          }
        });
      },
      sendIntention:function(){
        this.dialogMsgVisible = false;
        this.popupMsgVisible = false;
        this.tipsVisible = false;
        let para = {
          projectId:this.form.id,
          authorization: window.localStorage.getItem('Authorization')
          // 新意向不设置disposeStatus，表示对接中
        };
        reqBorrowIntentionAdd(para).then((res) => {
          if(res.data.code == 1){
            this.dialogMsgVisible = true;
          }else {
            this.$message({
              message: '提交失败',
              type: 'failed'
            });
          }
        });
      },
      getProjectByid:function (id) {
        var that=this;
        reqGetOneLoanProject({id:id}).then((res)=>{
          that.form = Object.assign({}, res.data.data);
          var publishTime=res.data.data.publishTime;
          var nowDate=new Date().getTime();
          var deadline=res.data.data.deadline*1000*60*60*24;
          if(publishTime+deadline-nowDate<0){
            this.form.realTimeStatus=2;
          }
          if(that.form.publishTime){
            that.form.publishTime=util.formatDate.format(new Date(that.form.publishTime),'yyyy-MM-dd')
          }
          reqGetDictionaryByIdList({ids: that.form.repaymentMethod}).then((res) => {
            var dictionarys = res.data.data;
            dictionarys.forEach(function (obj, i) {
              return that.form.repaymentMethod = obj.name;
            });
          });
          var gm = that.form.guaranteeMethod;
          if(gm != null && gm != '') {
            reqGetDictionaryByIdList({ids: gm}).then((res) => {
              var dictionarys = res.data.data;
              gm = '';
              dictionarys.forEach(function (obj, i) {
                gm += obj.name;
                if (i < (dictionarys.length - 1)){
                  gm += ', ';
                }
              });
              return that.form.guaranteeMethod = gm;
            });
          }
        })
      },
      getAttachments:function(id){
        var that=this;
        reqGetAttachmentsByProjId({id:id}).then((res) => {
          if(res.data.code===1){
            that.files = res.data.data;
          }
        });
      },
      getIntentions:function(id){
        var that=this;
        let para = {
          pageNum: that.pageNum,
          pageSize: that.pageSize,
          projectId: id,
          disposeStatus:0
        };
        reqGetBorrowIntentionByProjIdPage(para).then((res) => {
          if(res.data.code===1){
            that.total = res.data.data.total;
            that.intentions = res.data.data.list;
          }
        });
      },
      formatDate: function(row, column){
        if(row.transDate)
          return util.formatDate.format(new Date(row.transDate), 'yyyy-MM-dd');
      },
      isWechatBrowser: function () {
        let that=this;
        let ua = navigator.userAgent.toLowerCase();
        let isWeixin = ua.indexOf('micromessenger') !== -1;
        if (!isWeixin) {
          that.$router.push({name: 'wxError'});
        }
      },
      backWxLoanProjectSharing:function(id) {
        pushHistory();
        function bodyScroll(){
          window.location.href='/wxLoanProjectSharing?id='+id;
          window.removeEventListener("popstate", bodyScroll,false);
        }
        window.addEventListener("popstate",bodyScroll, false);
        function pushHistory() {
          var state = {
            title: "title",
            url: "#"
          };
          window.history.pushState(state, state.title, state.url);
        }
      },
      backWxProjectList:function() {
        pushHistory();
        function bodyScroll(){
          window.location.href='/wxProjectList';
        }
        window.addEventListener("popstate",bodyScroll, false)
        function pushHistory() {
          var state = {
            title: "title",
            url: ""
          };
          window.history.pushState(state, state.title, state.url);
        }
      }
    },
    mounted(){
      this.$store.dispatch('hideHF');
      var row=this.$route.query;
      if(row.projectDetail=='wxLoanProjectSharing'){
        this.backWxLoanProjectSharing(row.id);
      }
      if(row.wxLoanProjectSharing==2||row.projectDetail=='wxProjectList'){
        this.backWxProjectList();
      }
      if(row.wxMyLoan==1){
        pushHistory();
        function bodyScroll(){
          window.location.href='/wxMyborrow?userId='+row.userId;
          window.removeEventListener("popstate", bodyScroll,false);
        }
        window.addEventListener("popstate",bodyScroll, false);
        function pushHistory() {
          var state = {
            title: "title",
            url: ""
          };
          window.history.pushState(state, state.title, state.url);
        }
      }
      this.getProjectByid(row.id);
      this.getAttachments(row.id);
      this.getIntentions(row.id);
      this.isWechatBrowser();
    },
  }
</script>
<style slot-scope="scope">
  .viewer-close { background-color: rgba(244, 67, 54, .6); }
  .el-dialog__wrapper .el-dialog .el-dialog__body { line-height: 2; }
  @import '../../assets/css/wxstyle.css';
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxLoanProjectDetail.vue